enum Lang {
    RU = 'RU',
    EN = 'EN',
}

export default Lang
